import { DatePicker, Form, Upload, Select, Button, Modal, Input } from 'antd'
import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import SelectField from '../common/Select/SelectField'
import { upLoadImage } from '../../services/postservice'
import styles from './styles.module.scss'
import openNotification from '../common/Notification/openNotification '
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({ form, mode, type, displayOptions, displayOn }) => {
  const [fileList, setFileList] = useState([])
  const [fileListMobile, setFileListMobile] = useState([])
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState()
  const [previewTitle, setPreviewTitle] = useState()
  const imageUrl = Form.useWatch('image_url', form)
  const imageUrlMobile = Form.useWatch('image_url_mobile', form)

  const normalizeImageUrl = (value) => {
    if (typeof value === 'string') return value
    if (Array.isArray(value) && typeof value[0] === 'string') return value[0]
    if (value && typeof value === 'object') {
      if (typeof value.url === 'string') return value.url
      if (typeof value.link === 'string') return value.link
    }
    return ''
  }

  // Set fileList khi form có giá trị image_url
  useEffect(() => {
    const normalized = normalizeImageUrl(imageUrl)
    if (normalized) {
      setFileList([
        {
          uid: '-1',
          name: 'image',
          status: 'done',
          url: normalized
        }
      ])
    } else {
      setFileList([])
    }
  }, [imageUrl])

  useEffect(() => {
    const normalized = normalizeImageUrl(imageUrlMobile)
    if (normalized) {
      setFileListMobile([
        {
          uid: '-2',
          name: 'image_mobile',
          status: 'done',
          url: normalized
        }
      ])
    } else {
      setFileListMobile([])
    }
  }, [imageUrlMobile])

  // Xử lý khi người dùng tải lên file
  const handleChange = ({ fileList }, target = 'web') => {
    if (target === 'mobile') {
      setFileListMobile(fileList)
      return
    }
    setFileList(fileList)
  }

  const UploadButton = () => {
    return (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    )
  }

  const handlePreview = async (file) => {
    if (file.response) {
      setPreviewImage(file.response?.[0]?.link)
      setPreviewVisible(true)
      setPreviewTitle(false)
    } else {
      setPreviewImage(file.url)
      setPreviewVisible(true)
      setPreviewTitle(false)
    }
  }
  const handleCancel = () => {
    setPreviewVisible(false)
  }
  const handleCustomRequest = async (options, target = 'web') => {
    const { file, onSuccess, onError, onProgress } = options

    // Tạo FormData và append file vào formData
    const formData = new FormData()
    formData.append('file_image', file)
    try {
      // Gọi API upload thông qua hàm upLoadImage
      const response = await upLoadImage(formData)

      if (response?.data?.[0]?.link) {
        if (target === 'mobile') {
          form.setFieldValue('image_url_mobile', response.data[0].link)
        } else {
          form.setFieldValue('image_url', response.data[0].link)
        }
      }
      // Nếu có tiến trình upload, bạn có thể gọi onProgress
      if (onProgress) {
        onProgress({ percent: 100 })
      }
      // Gọi onSuccess của Upload để thông báo upload thành công
      onSuccess(response.data, file)
    } catch (error) {
      onError(error)
      openNotification(
        'error',
        error?.response?.data?.message || 'upload thất bại'
      )
    }
  }

  return (
    <Form
      form={form}
      // onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 5 }}
      layout="vertical"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      onValuesChange={(value, allValues) =>
        console.log('Form Data', value, allValues)
      }
      disabled={mode == 'VIEW' ? true : false}
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Hiển thị trên"
        name="display_on"
        rules={[{ required: true, message: 'Vui lòng chọn hiển thị ở đâu' }]}
        className={styles.formItem}
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Chọn hiển thị trên mobile/web"
          options={displayOn}
        />
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.display_on !== currentValues.display_on
        }
      >
        {({ getFieldValue }) =>
          getFieldValue('display_on') === 'Mobile' && (
            <>
              <Form.Item
                label="Loại"
                name="type"
                rules={[{ required: true, message: 'Vui lòng chọn loại' }]}
                className={styles.formItem}
              >
                <Select
                  style={{ width: '100%' }}
                  placeholder="Chọn loại"
                  options={type}
                />
              </Form.Item>

              <Form.Item
                label="Vị trí hiển thị"
                name="display_order"
                rules={[
                  { required: true, message: 'Vui lòng điền vị trí hiển thị' }
                ]}
                className={styles.formItem}
              >
                <Input />
              </Form.Item>
            </>
          )
        }
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.display_on !== currentValues.display_on
        }
      >
        {({ getFieldValue }) =>
          getFieldValue('display_on') === 'Web' && (
            <React.Fragment>
              <Form.Item
                label="Vị trí hiển thị"
                name="display_position"
                rules={[
                  { required: true, message: 'Vui lòng chọn vị trí hiển thị' }
                ]}
                className={styles.formItem}
              >
                <Select
                  style={{ width: '100%' }}
                  placeholder="Chọn vị trí hiển thị"
                  options={displayOptions}
                />
              </Form.Item>
              <Form.Item
                name="image_url_mobile"
                label="Tải ảnh mobile"
                // rules={[{ required: true, message: 'Vui lòng tải ảnh mobile' }]}
                className={styles.formItem}
              >
                <Upload
                  accept="image/*"
                  customRequest={(options) =>
                    handleCustomRequest(options, 'mobile')
                  }
                  onChange={(info) => handleChange(info, 'mobile')}
                  listType="picture-card"
                  fileList={fileListMobile}
                  onPreview={handlePreview}
                  multiple={false}
                  maxCount={1}
                  // disabled={mode === 'UPDATE'}
                >
                  {fileListMobile.length < 1 && <UploadButton />}
                </Upload>
              </Form.Item>
            </React.Fragment>
          )
        }
      </Form.Item>

      {/* Upload Ảnh */}
      <Form.Item
        name="image_url"
        label="Tải ảnh"
        rules={[{ required: true, message: 'Vui lòng tải ảnh' }]}
        // getValueFromEvent={(e) => e?.fileList}
        className={styles.formItem}
      >
        <Upload
          accept="image/*" // Chỉ cho phép upload file video
          // beforeUpload={beforeUploadImage} // Kiểm tra trước khi upload
          customRequest={(options) => handleCustomRequest(options, 'web')} // Sử dụng custom request để gọi API của bạn
          onChange={(info) => handleChange(info, 'web')}
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          multiple={false}
          maxCount={1}
          // Keep enabled in UPDATE so user can remove/re-upload like mobile image
        >
          {fileList.length < 1 && <UploadButton />}
        </Upload>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={handleCancel}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Form.Item>
    </Form>
  )
}

export default FormPost
